// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import cn from 'classnames';
import Check from '../../img/icons/24/check_line.svg';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {product_features} from '../products';
import styles from './pricing_checks.module.less';

interface i_pricing_checks_props {
    check_list: number[];
    short_checks?: boolean;
}

const Check_cube = ({text})=>{
    const {theme} = useContext(Settings_context);
    const {width} = use_screen();
    return <div className={styles.check_cube}>
      <Check />
      {width > 768 ? <p className={cn(theme.p14, theme.med)}>{text}</p> :
        <p className={cn(theme.p12, theme.med)}>{text}</p>}
    </div>;
};

export const Pricing_checks = (props: i_pricing_checks_props)=>{
    const {check_list} = props;
    return <div className={cn(styles.checks,
      props.short_checks && styles.short)}>
      {check_list.map((check, index)=>{
        const text = product_features[check];
        return text ? <Check_cube key={index} text={text} /> : null;
      })}
    </div>;
};
